import React, { useState } from 'react';
import { Alert, Button, Container, Form, Row, Col } from 'react-bootstrap';
import { FaEnvelope, FaFacebookF, FaInstagram, FaPaperPlane } from 'react-icons/fa';

function Contato() {
  const contactEmail = process.env.REACT_APP_CONTACT_EMAIL;
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    assunto: '',
    mensagem: ''
  });
  const [status, setStatus] = useState(null);

  const canais = [
    {
      titulo: 'E-mail',
      descricao: 'contato@acessopopular.org.br',
      icone: <FaEnvelope />,
      link: contactEmail ? `mailto:${contactEmail}` : null
    },
    {
      titulo: 'Instagram',
      descricao: '@acessopopular',
      icone: <FaInstagram />,
      link: 'https://www.instagram.com/acessopopular/',
    
    },
    {
      titulo: 'Facebook',
      descricao: 'facebook.com/acessopopularbauru',
      icone: <FaFacebookF />,
      link: 'https://www.facebook.com/acessopopularbauru',
    }
  ];

  const handleChange = ({ target }) => {
    const { name, value } = target;

    setFormData((currentData) => ({
      ...currentData,
      [name]: value
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const { nome, email, assunto, mensagem } = formData;

    if (!nome.trim() || !email.trim() || !assunto.trim() || !mensagem.trim()) {
      setStatus({
        type: 'danger',
        message: 'Preencha todos os campos antes de enviar sua mensagem.'
      });

      return;
    }

    const emailValido = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    if (!emailValido) {
      setStatus({
        type: 'danger',
        message: 'Informe um e-mail válido para continuarmos o contato.'
      });

      return;
    }

    if (!contactEmail) {
      setStatus({
        type: 'warning',
        message: 'O formulário está pronto, mas o e-mail de destino ainda não foi configurado. Defina REACT_APP_CONTACT_EMAIL para habilitar o envio direto.'
      });

      return;
    }

    const subject = encodeURIComponent(`[Contato site] ${assunto}`);
    const body = encodeURIComponent(
      `Nome: ${nome}\nE-mail: ${email}\n\nMensagem:\n${mensagem}`
    );
    const mailtoUrl = `mailto:${contactEmail}?subject=${subject}&body=${body}`;
    const emailLink = document.createElement('a');

    emailLink.href = mailtoUrl;
    emailLink.click();

    setStatus({
      type: 'success',
      message: 'Abrimos seu aplicativo de e-mail com a mensagem preenchida. Revise e conclua o envio por lá.'
    });
  };

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <Container>
          <Row className="align-items-end g-4">
            <Col lg={8}>
              <div className="contact-hero-copy">
                <span className="contact-kicker">Fale com o instituto</span>
                <h1>Contato</h1>
                <p>
                  Entre em contato para tirar dúvidas, apresentar propostas, construir parcerias ou enviar mensagens sobre as ações do Instituto Acesso Popular.
                </p>
              </div>
            </Col>
            <Col lg={4}>
              <div className="contact-hero-panel">
                <div>
                  <strong>Atendimento institucional</strong>
                  <span>Canal para diálogo, articulação cultural e mensagens gerais.</span>
                </div>
                <div>
                  <strong>Redes ativas</strong>
                  <span>Instagram e Facebook disponíveis para acompanhamento e contato.</span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="contact-content-section">
        <Container>
          <Row className="g-4 align-items-stretch">
            <Col lg={7}>
              <div className="contact-form-card">
                <div className="contact-section-heading">
                  <span>Envie uma mensagem</span>
                  <h4 className='mt-2'>Formulário de contato</h4>
                </div>
                {status && <Alert variant={status.type}>{status.message}</Alert>}
                <Form onSubmit={handleSubmit}>
                  <Row className="g-3">
                    <Col md={6}>
                      <Form.Group controlId="contatoNome">
                        <Form.Label>Nome</Form.Label>
                        <Form.Control
                          type="text"
                          name="nome"
                          value={formData.nome}
                          onChange={handleChange}
                          placeholder="Seu nome"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="contatoEmail">
                        <Form.Label>E-mail</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="voce@exemplo.com"
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12}>
                      <Form.Group controlId="contatoAssunto">
                        <Form.Label>Assunto</Form.Label>
                        <Form.Control
                          type="text"
                          name="assunto"
                          value={formData.assunto}
                          onChange={handleChange}
                          placeholder="Sobre o que voce deseja falar?"
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12}>
                      <Form.Group controlId="contatoMensagem">
                        <Form.Label>Mensagem</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={6}
                          name="mensagem"
                          value={formData.mensagem}
                          onChange={handleChange}
                          placeholder="Escreva sua mensagem aqui"
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12}>
                      <div className="contact-form-footer">
                        <Button type="submit" variant="danger" className="contact-button-primary">
                          <FaPaperPlane />
                          <span> Enviar mensagem</span>
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
            <Col lg={5}>
              <div className="contact-side-stack">
                <div className="contact-info-card">
                  <div className="contact-section-heading compact">
                    <span>Canais</span>
                    <h4 className='mt-2'>Outras formas de contato</h4>
                  </div>
                  <div className="contact-channel-list">
                    {canais.map((canal) => (
                      <div className="contact-channel-item" key={canal.titulo}>
                        <div className="contact-channel-icon">{canal.icone}</div>
                        <div className="contact-channel-copy">
                          <h3>{canal.titulo}</h3>
                          {canal.link ? (
                            <p>
                              <a href={canal.link} target="_blank" rel="noreferrer">
                                {canal.descricao}
                              </a>
                            </p>
                          ) : (
                            <p>{canal.descricao}</p>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default Contato;